import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { INPUT_TOOLBAR_HIT_SLOP } from './constants';
import { Message } from './types';
import { SendProps } from 'react-native-gifted-chat';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

export const ChatSendButton: React.FC<SendProps<Message>> = ({
  disabled,
  onSend,
  text,
}) => {
  return (
    <TouchableOpacity
      disabled={disabled}
      hitSlop={INPUT_TOOLBAR_HIT_SLOP}
      onPress={() => {
        Analytics.track('chat.send_button.press');

        const message = text?.trim() || '';
        if (message) {
          onSend?.({ text: message }, true);
        }
      }}
      style={disabled ? styles.disabled : null}
      testID="chat-send-button"
    >
      <Text style={TYPOGRAPHY.pSemiBold}>{i18n.t('send')}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  disabled: {
    opacity: 0.2,
  },
});
